import React, { useState, useEffect, useRef } from "react";
import Title from "../Title/Title";
import Button from "../Button/Button";
import Desc from "../Desc/Desc";
import Paragraph from "../Paragraph/Paragraph";
import styles from "./Result.module.scss";
import classNames from "classnames";
import { SITE_URL } from "../../state/consts";
import { IconButton, Snackbar } from "@mui/material";
import ShareIcon from "@mui/icons-material/Share";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";

import { FacebookShareButton, WhatsappShareButton } from "react-share";

import { FacebookIcon, WhatsappIcon } from "react-share";

function Result({
  score,
  title,
  text,
  imageSrc,
  posterContainer,
  optionsContainer,
  handlerBack,
}) {
  const [offset, setOffset] = useState(false);
  const [copySuccess, setCopySuccess] = useState("");
  const [showConditions, setShowConditions] = useState(false);
  const textAreaRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setOffset(true);
      } else {
        setOffset(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const ImageURL = SITE_URL + imageSrc;

  // кнопка скопировать
  const [open, setOpen] = useState(false);

  const testClick = () => {
    setOpen(true);
    navigator.clipboard.writeText(window.location.toString());
  };

  function copyToClipboard(e) {
    textAreaRef.current.select();
    console.log(textAreaRef.current.value);
    document.execCommand("copy");
    e.target.focus();
    setCopySuccess(
      <div className={styles.copySuccess}>Промокод скопирован.</div>,
    );

    setTimeout(() => {
      setCopySuccess(
        <div className={classNames(styles.copySuccess, styles.displayNone)}>
          Промокод скопирован.
        </div>,
      );
    }, "1500");
  }

  return (
    <>
      {!showConditions ? (
        <>
          <div className={posterContainer}>
            <img src={imageSrc} className={styles.image} alt="" />
          </div>
          <div className={classNames(optionsContainer, styles.before)}>
            <div
              className={classNames({
                [styles.resultPosterContainer]: true,
                [styles.onScrollOption]: offset,
              })}
            >
              <div className={styles.contentWrapper}>
                <div className={styles.score}>{score}</div>
                <Title value={title} />
                {text}
                <Desc
                  value={
                    "ขั้นตอนการเลือกซื้อกะในแอป:เข้าที่ เมนู →  การเงิน→  แพ็คเกจเหมาจ่ายค่าคอมฯ "
                  }
                />
              </div>

              <div className={styles.buttonBox}>
                <a
                  href="https://taximaxim.com/link/taxseedriver%253A%252F%252Fapp%253Faction%253Dbuyshifts"
                  target="_blank"
                  rel="noreferrer"
                >
                  <Button
                    value="ไปที่แอป"
                    id="onelink"
                    className={styles.buttonPresent}
                  />
                </a>

                <div
                  className={styles.buttonBoxLink}
                  onClick={() => {
                    setShowConditions(true);
                  }}
                >
                  ดูข้อมูลทางด้านกฎหมาย
                </div>
              </div>

              <div
                className={classNames(
                  styles.contentWrapper,
                  styles.socialWrapper,
                )}
              >
                <Paragraph value="แชร์" />
                <div className={styles.social}>
                  <FacebookShareButton
                    url={SITE_URL}
                    title="เคล็ดลับเพิ่มรายได้จากการขับรถอยู่นี่! 👉 ลองทำแบบทดสอบเลย มีคำตอบอยู่ในตอนท้าย"
                    image={ImageURL}
                    hashtag="#Maxim"
                    id="facebook"
                  >
                    <FacebookIcon
                      size={48}
                      round={true}
                      className={classNames(styles.icon, styles.facebook)}
                    />
                  </FacebookShareButton>

                  <WhatsappShareButton
                    url={SITE_URL}
                    title="เคล็ดลับเพิ่มรายได้จากการขับรถอยู่นี่! 👉 ลองทำแบบทดสอบเลย มีคำตอบอยู่ในตอนท้าย"
                    image={ImageURL}
                    id="whatsapp"
                  >
                    <WhatsappIcon
                      size={48}
                      round={true}
                      className={classNames(styles.icon, styles.whatsapp)}
                    />
                  </WhatsappShareButton>

                  <div id="sharelink">
                    <IconButton
                      onClick={testClick}
                      color="primary"
                      className={styles.share}
                    >
                      <ShareIcon />
                    </IconButton>
                    <Snackbar
                      message="คัดลอกลิงก์"
                      anchorOrigin={{ vertical: "top", horizontal: "center" }}
                      autoHideDuration={1000}
                      onClose={() => setOpen(false)}
                      open={open}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          {copySuccess}
        </>
      ) : (
        <>
          <div className={styles.posterContainer}>
            <img src={imageSrc} className={styles.image} alt="" />
          </div>
          <div className={styles.resultContainer} m2>
            <div
              className={classNames({
                [styles.resultContainerBox]: true,
                [styles.onScrollOption]: offset,
              })}
            >
              <div>
                <Title value="License agreement" />
                <Paragraph value="This License Agreement describes how MAXIM (collectively hereinafter as «Maxim», «us», «our» or «we») grants the right to use the mobile application(s) operated by Maxim (respectively hereinafter as «Apps»), and our products or features in the Apps, designed to search for orders for the provision of certain services, accept these orders for execution and inform the Client about the progress of the service. This License Agreement applies to every User of our Apps which means including but not limited to Drivers and Partners (collectively hereinafter referred to as «User», «Partner», «you», «your» or «yours»)." />
                <Paragraph value="Unless the Parties have agreed otherwise through the separate Contract, this Agreement is the adhesion contract and is awarded in a simplified manner via adhesion to the terms and conditions of the Agreement posted on the website (https://legal.taximaxim.com/) hereinafter referred to as MAXIM website)." />
                <Paragraph value="A User who passed through the registration procedure, described herein, shall be deemed to have accepted the Agreement, which is akin to awarding a civil law contract on the terms and conditions set forth herein. Before passing the registration procedure, carefully read the text of the Agreement. In case of disagreement with any terms, you must refuse to use the Mobile Application." />
                <b>
                  <Paragraph value="SECTION I." />
                </b>
                <b>
                  <Paragraph value="GENERAL PROVISIONS" />
                </b>
                <Paragraph value="For the purpose of this License Agreement, the below listed terms shall be interpreted as follows:" />
                <ol>
                  <li>
                    <Paragraph value="«MAXIM»: The company or its subsidiaries or its partners, which are legal entities granting the rights to the Partner to use the Apps, according to the license agreement and granting the rights to the Partner to use authorized Apps, and who focused on receiving, processing and transmission of the Client’s order to the Partner and communicating the Order follow-up status to the Client." />
                  </li>
                  <li>
                    <Paragraph value="«Authorized Mobile Application (App)»: A computer program installed on mobile devices and designed to search for orders for the provision of certain services, accept these orders for execution and inform the Client about the progress of the service." />
                  </li>
                  <li>
                    <Paragraph value="«Partner»:  A person who has expressed his/her/its acceptance of the license agreement and has received the right to use the Apps thereunder." />
                  </li>
                  <li>
                    <Paragraph value="«Client»:  A person who has requested the  Services via the Maxim Apps or the website, and has provided his Personal Data for this purpose." />
                  </li>
                  <li>
                    <Paragraph value="«Services» means services that are provided by the Partner to the Client and ordered through Authorized Mobile Application." />
                  </li>
                  <li>
                    <Paragraph value="«Order»: The information placed in the Mobile Application and containing data about the demand for the provision of the Services and having certain parameters, depending on the type of the Services." />
                  </li>
                  <li>
                    <Paragraph value="«Transportation Company»: A legal entity registered in the manner prescribed by the current legislation of the Kingdom of Thailand , which possesses all the permits and licenses necessary to provide transportation services by car, including execution of orders received from online transportation services via Apps, and gains the access to the Apps under a separate license agreement." />
                  </li>
                  <li>
                    <Paragraph value="«Cost of the Services»: The amount of money paid to the Partner by the Client for the provision of the Services." />
                  </li>
                  <li>
                    <Paragraph value="«Personal Account»: An account where the Partner’s advance payments are recorded and from which funds are debited as a payment for obtaining the right to use the Mobile Application." />
                  </li>
                  <li>
                    <Paragraph value="«Personal Account Balance»: The difference at a certain time points between the amounts deposited in the Personal Account and debited from the Personal Account." />
                  </li>
                </ol>
                <b>
                  <Paragraph value="SECTION II." />
                </b>
                <b>
                  <Paragraph value="SUBJECT OF THE AGREEMENT" />
                </b>
                <ol>
                  <li>
                    <Paragraph value="MAXIM hereby provides free information services focused on the transmission of the Order to the Partner and communicating the Order follow-up status to the Client." />
                  </li>
                  <li>
                    <Paragraph value="In accordance with the provisions of this Agreement, MAXIM gives the Partner the rights to use the Apps containing up-to-date information on existing demand for conveyance of transportation services by car or motorbike, cargo delivery services or loading/unloading services, massage and spa services, cleaning services, and any of the services listed in the Maxim Apps or on the Maxim website, on conditions of simple (nonexclusive) license in the manner set forth herein, and the Partner shall pay a fee to MAXIM in the manner and size set forth herein and/or its appendix (appendices)." />
                  </li>
                  <li>
                    <Paragraph value="For the purpose of this Agreement, the order-related materials may be accessed through authorized platforms, namely the Apps." />
                  </li>
                  <li>
                    <Paragraph value="Acquisition, storage, systemization of information, order management, as well as legal relations between the Partner and MAXIM in respect of granting access to the Apps are subject to the provisions of regulations which are binding according to  laws and regulations of the Kingdom of Thailand." />
                  </li>
                  <li>
                    <Paragraph value="The Partner may use information, access to which he/she is granted to, at his/her discretion." />
                  </li>
                  <li>
                    <Paragraph value="The territory, where the right to use the Apps is provided, is the territory of  the Kingdom of Thailand." />
                  </li>
                  <li>
                    <Paragraph value="As a result of placing the Order by the Client and the Partner accepting it on the terms agreed between them, a contract for rendering of Services is created, to which MAXIM is not a party." />
                  </li>
                </ol>
                <b>
                  <Paragraph value="SECTION III." />
                </b>
                <b>
                  <Paragraph value="REGISTRATION" />
                </b>
                <ol>
                  <li>
                    <Paragraph value="For Partners who provide specific services such as massage and SPA service(s) and/or cleaning service(s), there will be an additional agreement with MAXIM that is the integral part hereof." />
                  </li>
                  <li>
                    <Paragraph value="To get access to the Apps, you need to personally go through the registration process (hereafter referred to as the registration) on MAXIM website on the Internet or locally in MAXIM office." />
                  </li>
                  <li>
                    <Paragraph value="Registration on MAXIM website shall be deemed to be completed and unconditional accession to the conditions hereof." />
                  </li>
                  <li>
                    <Paragraph value="Registration is exercised through filling a special form on MAXIM website. MAXIM may request to provide the documents supporting the authenticity of the data mentioned during registration." />
                  </li>
                  <li>
                    <Paragraph value="Registration is carried out at the discretion of MAXIM. Documents and data required for registration shall not entail the absolute obligation of MAXIM to exercise the registration procedure." />
                  </li>
                  <li>
                    <Paragraph value="The user’s ID (login) and password required to get the authorized access to the Apps is assigned after registration. The user’s ID (login) and password are sent by MAXIM to the phone number, which was mentioned at the stage of registration." />
                  </li>
                  <li>
                    <Paragraph value="MAXIM may, from time to time, request to provide personal data and documents solely for verification of data provided." />
                  </li>
                  <li>
                    <Paragraph value="MAXIM saves and uses the following data on the persons, who have registered on MAXIM website:" />
                  </li>
                  <ol type="a">
                    <li>
                      <Paragraph value=" The user’s pseudonym (nickname) is any combination of letters mentioned at registration. The Partner specifies his pseudonym at his discretion and is not modified by MAXIM;" />
                    </li>
                    <li>
                      <Paragraph value="The user’s ID (login);" />
                    </li>
                    <li>
                      <Paragraph value="Brand, color and digits from the vehicle’s registration plate;" />
                    </li>
                    <li>
                      <Paragraph value="Mobile phone number mentioned at registration." />
                    </li>
                  </ol>
                  <li>
                    <Paragraph value="By registering on MAXIM website, the Partner hereby expresses his consent to receive promotional ads in any way particularly through the telecommunication channels and Internet messengers (Viber, WhatsApp, Telegram and similar) for the purposes and in cases, when such consent is required according to binding laws." />
                  </li>
                  <li>
                    <Paragraph value="The Partner may use the Apps in the following manner:" />
                  </li>
                  <ol type="a">
                    <li>
                      <Paragraph value="Acquire information from the platform and use such information in his/her business, particularly provide access to such information to the third parties (his/her employees, contractors and etc.)" />
                    </li>
                    <li>
                      <Paragraph value=" The Partner must not, completely or partially, reproduce the platform and the Apps in any format and by any means;" />
                    </li>
                    <li>
                      <Paragraph value="The Partner must not modify the platform and the Apps, including but not limited to translating from one language to another;" />
                    </li>
                  </ol>
                </ol>
                <b>
                  <Paragraph value="SECTION IV." />
                </b>
                <b>
                  <Paragraph value="RIGHTS, RESPONSIBILITIES, AND GUARANTEES OF THE PARTIES" />
                </b>
                <ol>
                  <li>
                    <Paragraph value="MAXIM hereby guarantees that:" />
                  </li>
                  <ol type="a">
                    <li>
                      <Paragraph value="performance of this Agreement by the Parties shall not entail the violation of any third parties’ intellectual rights;" />
                    </li>
                    <li>
                      <Paragraph value="it is not bound by any contract that can prevent the Partner from using the Mobile Application on the terms set forth in this Agreement;" />
                    </li>
                    <li>
                      <Paragraph value="it has  the sufficient scope of rights to fulfill its obligations under this Agreement;" />
                    </li>
                    <li>
                      <Paragraph value="performed nor will perform any actions making it impossible for the Partner to use the Mobile Application on the terms set forth in this Agreement." />
                    </li>
                  </ol>
                  <li>
                    <Paragraph value="MAXIM has the right to:" />
                  </li>
                  <ol type="a">
                    <li>
                      <Paragraph value="Request the Partner to use the Apps in the manner and form set forth herein;" />
                    </li>
                    <li>
                      <Paragraph value="Similar to this Agreement, award agreements for assignment of rights to use the Apps with the third parties, particularly on the same territory, where the rights to use the Apps is given to the Partner;" />
                    </li>
                    <li>
                      <Paragraph value="Suspend access to the Apps to the Partner, should the Partner violate the conditions and fee payment due date for MAXIM – until the fee is paid by the Partner." />
                    </li>
                    <li>
                      <Paragraph value="Suspend access to the Apps of the Partner, should MAXIM receive the documents evidencing the Partner’s illegal use of the Order information. MAXIM suspends access to Apps of the Partner based on the effective judgments, regulations, which prove the fact of violation by the Partner. These documents shall be submitted in the original or in copies certified by the appropriate court. Access of the Partner to the Apps shall suspended till Partner clears all violations disclosed." />
                    </li>
                    <li>
                      <Paragraph value="record phone calls with the Partner to ensure internal control of the quality of granting access to the Apps to the Partner and quality of provision of Services for grating such access;" />
                    </li>
                    <li>
                      <Paragraph value="carry out scheduled maintenance  and functional modification of the Apps. For a period, while such works are in progress the Partner may be suspended from access to the Apps." />
                    </li>
                    <li>
                      <Paragraph value="suspend access to the Apps to the Partner, should the Personal Account balance become null or negative until the time the Partner tops it up." />
                    </li>
                    <li>
                      <Paragraph value="take any other actions including but not limited to granting and maintaining access to the Apps. The above-mentioned actions must not contradict with any binding  laws or regulations of the Kingdom of Thailand." />
                    </li>
                  </ol>
                  <li>
                    <Paragraph value="Towards the Partner, MAXIM shall:" />
                  </li>
                  <ol type="a">
                    <li>
                      <Paragraph value="Provide smooth and continuous functioning of the Apps for the Partner throughout the period of the Agreement except for cases of scheduled maintenance and modification of the Apps, as well as in cases of malfunction;" />
                    </li>
                    <li>
                      <Paragraph value="grant the right to the Partner to use the Apps;" />
                    </li>
                    <li>
                      <Paragraph value="timely account the Partner’s payments on his/her Personal account." />
                    </li>
                    <li>
                      <Paragraph value="timely figure out and prevent any efforts of unauthorized access to the Partner’s data and/or its transfer to the third parties, who do not have a direct relation to the legal relationship between the parties;" />
                    </li>
                    <li>
                      <Paragraph value="not change or edit the Partner’s data without his/her consent." />
                    </li>
                  </ol>
                  <li>
                    <Paragraph value="The Partner has the right to:" />
                  </li>
                  <ol type="a">
                    <li>
                      <Paragraph value="request MAXIM to grant access to the Apps of proper quality subject to the conditions of these provisions, including technical and consulting services;" />
                    </li>
                    <li>
                      <Paragraph value="Use the Apps in the manner and form set forth herein;" />
                    </li>
                    <li>
                      <Paragraph value="Request MAXIM to immediately resolve any problems, preventing the use of the Apps." />
                    </li>
                  </ol>
                  <li>
                    <Paragraph value="The Partner shall:" />
                  </li>
                  <ol type="a">
                    <li>
                      <Paragraph value="execute the accepted Order in accordance with its conditions;" />
                    </li>
                    <li>
                      <Paragraph value="pay MAXIM for services provided in respect of granting access to the Apps at the price set forth in these Agreement;" />
                    </li>
                    <li>
                      <Paragraph value="Should MAXIM make any pay-outs to the Clients caused by poor quality of Services provided by the Partner (Partner’s employees and/or contractors) to the Clients, the Partner hereby obliges to compensate for losses incurred by MAXIM in this regard. This compensation is deducted from cash available on the Partner’s personal account. In case the sum is not sufficient, penalties for the fiscal period shall be deemed to be the Partner’s accounts receivable, which is set off as a matter of priority, once the Partner tops up his Personal account. Poor quality of Services provided by the Partner is confirmed through the inspections, carried out by the MAXIM employees, which are initiated on the basis of the Clients requests, the result of which is formalized with the office memos, generated in MAXIM software-information complex;" />
                    </li>
                    <li>
                      <Paragraph value="immediately notify MAXIM, should the registration details, provided to MAXIM at the stage of awarding the license agreement and occurrence of circumstances making it impossible to close the Orders." />
                    </li>
                    <li>
                      <Paragraph value="use the appropriate road safety equipment while driving or on the road;" />
                    </li>
                    <li>
                      <Paragraph value="only use a Vehicle in good operating condition and meets the industry safety standards for Vehicles of its kind;" />
                    </li>
                    <li>
                      <Paragraph value="Comply with all laws and regulations of the Kingdom of Thailand related to the operation of a taxi/passenger delivery and/or other types of transport services and will be solely responsible for any violations of such laws and regulations;" />
                    </li>
                    <li>
                      <Paragraph value="not contact the Client for purposes other than in connection with the Service;" />
                    </li>
                    <li>
                      <Paragraph value="bear the standard telecommunication charges that may apply when responding to the Client;" />
                    </li>
                    <li>
                      <Paragraph value="keep the personal account password or any identification which allows access to the Authorized Mobile Applications secure and confidential. If The Partner share the account password or any identification (including without limitation authentication code) with or otherwise disclose them to any third parties such as The Partner’s partners or employees, The Partner agrees that the third parties shall have the authority to act on The Partner's behalf (including without limitation indicate acceptance to any additional terms as MAXIM may make available to you whether via the Application or otherwise);" />
                    </li>
                  </ol>
                  <li>
                    <Paragraph value="MAXIM is not responsible for:" />
                  </li>
                  <ol type="a">
                    <li>
                      <Paragraph value="complete or partial interruptions of access to the Apps by the Partner, which are caused by the replacement of hardware and software or some other scheduled works dictated by the need to maintain performability and development of MAXIM firmware." />
                    </li>
                    <li>
                      <Paragraph value="the Partner’s failure to get access to the Apps in case of the third-party hardware or software failures, which do not belong to MAXIM." />
                    </li>
                    <li>
                      <Paragraph value="the Partner’s damages, lost profit suffered by the Partner because of use of the Apps by the Partner." />
                    </li>
                    <li>
                      <Paragraph value="the damage inflicted on the third-parties by the Partner resulting from the use of the Apps by the Partner." />
                    </li>
                    <li>
                      <Paragraph value="any interruptions in the provision of Services in the event of software or hardware failures not belonging to MAXIM." />
                    </li>
                    <li>
                      <Paragraph value="a complete or partial interruption in the provision of Services related to replacement of hardware, software or other attempts required to maintain MAXIM’s performability and development of hardware subject to prior notice of the Client." />
                    </li>
                    <li>
                      <Paragraph value="direct damages, lost profit incurred by the Client as a result of use of Services rendered by the Partner." />
                    </li>
                    <li>
                      <Paragraph value="the Partner’s failure to perform his duties and any damages suffered by the Client due to such failure." />
                    </li>
                  </ol>
                </ol>
                <b>
                  <Paragraph value="SECTION V." />
                </b>
                <b>
                  <Paragraph value="ORDER COST, SIZE OF FEE PAYABLE, AND SETTLEMENT" />
                </b>
                <ol>
                  <li>
                    <Paragraph value="The cost of the Order is determined by the Partner and must comply with national or local tariff regulation set by the regulator/government." />
                  </li>
                  <li>
                    <Paragraph value="The Partner shares the applicable fares to MAXIM. MAXIM calculates the cost of the Order based on the details provided by the Partner, considering the parameters of each Order separately." />
                  </li>
                  <li>
                    <Paragraph value="The cost of the Services can be increased by the Client." />
                  </li>
                  <li>
                    <Paragraph value="The payment of remuneration shall be made by the Partner on a prepayment basis, the Partner shall deposit funds to the Personal Account in the amount determined by the Partner independently." />
                  </li>
                  <li>
                    <Paragraph value="The payment of remuneration shall be carried out by debiting funds from the Partner’s Personal Account in the amount equal to the remuneration amount, once the Order is accepted for execution." />
                  </li>
                  <li>
                    <Paragraph value="Replenishment of the Personal Account can be carried out by making advance payments by means of bank cards, through self-service terminals, by transferring funds to the settlement account or depositing funds at the cash office of the Service. Availability of replenishment options can be clarified in MAXIM offices." />
                  </li>
                  <li>
                    <Paragraph value="The size of the fee payable for the access and right to use the mobile app(s) shall be determined as percentage deductions of the Partner’s income (earnings) and with additional Value Added Tax (VAT) of the deduction amount." />
                  </li>
                  <li>
                    <Paragraph value="The size of the fee payable and its VAT is determined for every order separately and shall be specified in the information about the Order accepted by the Partner for execution in the Apps." />
                  </li>
                  <li>
                    <Paragraph value="The cost of the Order and/or the size of the fee may be reduced for a period of promotional offers. In this case reduction of the fee shall be the discount as provided. The discount size as well as conditions to get such discount shall be determined by the conditions of the respective promotional offer." />
                  </li>
                  <li>
                    <Paragraph value="Positive balance of the personal account of the Partner shall deem creditor indebtedness of MAXIM to the Partner." />
                  </li>
                  <li>
                    <Paragraph value="Negative balance of the personal account of the Partner shall deem indebtedness of the Partner to MAXIM under the License Agreement." />
                  </li>
                  <li>
                    <Paragraph value="The Partner shall be entitled to request payment of the indebtedness from MAXIM by sending an electronic request; the bank details of the bank card are specified in the authorized mobile application." />
                  </li>
                  <li>
                    <Paragraph value="Should the Partner gain the access not directly from MAXIM but on the basis of an agreement concluded between the Partner and any Transportation Company, MAXIM shall have the right, acting as an agent of the corresponding Transportation Company, to deduct the remuneration of this Transportation Company from the Personal Account of the Partner in the amount provided for by such agreement." />
                  </li>
                  <li>
                    <Paragraph value="The Partner shall be an independent economic entity and he is solely and completely responsible before tax and insurance issues." />
                  </li>
                </ol>
                <b>
                  <Paragraph value="SECTION VI." />
                </b>
                <b>
                  <Paragraph value="SELLING ACCESS TO «SHIFT»" />
                </b>
                <ol>
                  <li>
                    <Paragraph value="MAXIM may offer Partners an optional prepaid platform access feature known as «Shifts,» under which Partners may, by paying a predetermined fixed fee, access the platform during a specified period without being charged commission or additional per-order service fees for orders completed during such period. This feature is designed as a pricing and cost-management option to allow Partners to better manage their expenses and reduce the need to maintain a prepaid balance." />
                  </li>
                  <li>
                    <Paragraph value="The purchase of Shifts is entirely voluntary and is not a mandatory condition for accessing or using the platform." />
                  </li>
                  <li>
                    <Paragraph value="Purchasing Shifts does not create an employment relationship, does not constitute an assignment of work, and does not guarantee any minimum number of orders, level of activity, or earnings. MAXIM does not guarantee that purchasing Shifts will result in increased orders or income." />
                  </li>
                  <li>
                    <Paragraph value="Shift fees are paid solely for temporary access conditions and pricing arrangements of the platform and do not represent remuneration, wages, or compensation for work performed." />
                  </li>
                  <li>
                    <Paragraph value="Refunds (if any), availability of the Shifts feature, and applicable conditions shall be subject to MAXIM’s policies and may be affected by system limitations, force majeure events, or compliance with applicable laws or regulatory requirements in the Kingdom of Thailand." />
                  </li>
                </ol>
                <b>
                  <Paragraph value="SECTION VII." />
                </b>
                <b>
                  <Paragraph value="FORCE MAJEURE" />
                </b>
                <ol>
                  <li>
                    <Paragraph value="A force majeure shall be the reason releasing the Parties of their responsibilities. For the purpose hereof the force majeure shall mean circumstances set forth in  legal system of the Kingdom of Thailand." />
                  </li>
                  <li>
                    <Paragraph value="The Party, which has suffered from force majeure, shall immediately inform the other party in writing (including fax) of the force majeure, its type, the potential duration thereof and the obligations, which performance is interfered." />
                  </li>
                  <li>
                    <Paragraph value="Should the Party affected by force majeure, fails to inform the other Party in writing or via email thereof, it shall further lose its right to refer to the force majeure as to the circumstance that may release it of its responsibility." />
                  </li>
                </ol>
                <b>
                  <Paragraph value="SECTION VIII." />
                </b>
                <b>
                  <Paragraph value="DISPUTE SETTLEMENT" />
                </b>
                <ol>
                  <li>
                    <Paragraph value="The Parties shall take efforts to amicably settle down any disputes and disagreements thereunder by way of negotiations." />
                  </li>
                  <li>
                    <Paragraph value="The complaint response time and documents submission time for amicable settlement of disputes and disagreements shall not exceed seven (7) business days once the Party has received such complaint and/or the need to submit these documents has originated." />
                  </li>
                  <li>
                    <Paragraph value="Should it be not possible to settle down the disputes and disagreements by way of negotiations, the disputes and disagreements shall be settled subject to current  binding laws and/or regulations of the Kingdom of Thailand." />
                  </li>
                </ol>
                <b>
                  <Paragraph value="SECTION IX." />
                </b>
                <b>
                  <Paragraph value="JURISDICTION AND CROSS BORDER TRANSFER" />
                </b>
                <Paragraph value="Your data can be stored and processed in any country, state and city where we have facilities or in which we engage service providers. By accepting your consent to the transfer of information to countries outside your country of residence, which can have data protection rules that are different from the Kingdom of Thailand. In certain circumstances, courts, law enforcement agencies, regulatory agencies or security authorities in other countries may be entitled to access your data." />
                <b>
                  <Paragraph value="SECTION X." />
                </b>
                <b>
                  <Paragraph value="INTELLECTUAL PROPERTY" />
                </b>
                <ol>
                  <li>
                    <Paragraph value="The Partner is given a limited right to use «MAXIM» brand to advertise Order placing options." />
                  </li>
                  <li>
                    <Paragraph value="The Partner may independently advertise (promote) telephone number, other options of placing the Order, particularly by placing the promo ads on the Partner’s vehicles. In this case, the Partner is responsible for compliance with the promo ads (including its content and placement) with the requirements and regulations of the current law." />
                  </li>
                </ol>
                <b>
                  <Paragraph value="SECTION XI." />
                </b>
                <b>
                  <Paragraph value="SPECIAL CONDITIONS AND LIMITATION OF RESPONSIBILITY" />
                </b>
                <ol>
                  <li>
                    <Paragraph value="IN CONSIDERATION OF THE CONDITIONS HEREOF, THE PARTNER UNDERSTANDS THAT INFORMATION HE/SHE/IT IS GRANTED ACCESS TO HEREUNDER, IS USED BY HIM/HER PERSONALLY, FOR HIS OWN BENEFIT AND AT HIS RISK. THE PARTNER IS INFORMED THAT SHOULD HE/SHE/IT USE SUCH INFORMATION FOR BUSINESS PURPOSE, HE/SHE/IT SHALL PERSONALLY REGISTER AS A SOLE PROPRIETOR OR ACT AS A LEGAL ENTITY, AS WELL AS ENSURE COMPLIANCE WITH THE BINDING  LAWS OF THE KINGDOM OF THAILAND AND REGULATIONS" />
                  </li>
                  <li>
                    <Paragraph value="MAXIM SHALL NOT ASSUME ANY OBLIGATIONS IN RESPECT OF COMPENSATION FOR DAMAGE, PARTICULARLY LOST PROFIT INFLICTED ON THE THIRD PARTIES BY THE PARTNER’S ACTIONS." />
                  </li>
                  <li>
                    <Paragraph value="MAXIM IS NOT RESPONSIBLE TO THE PARTNER FOR ANY ACTIONS OF THE THIRD PARTIES, WHEN THE PARTNER HAS SUFFERED ANY DAMAGE, INCLUDING LOST PROFIT." />
                  </li>
                </ol>
                <b>
                  <Paragraph value="SECTION XII." />
                </b>
                <b>
                  <Paragraph value="THE CHANGE OR UPDATES OF THIS POLICY" />
                </b>
                <ol>
                  <li>
                    <Paragraph value="Amendments to this Agreement shall be made by the Platform unilaterally by publishing the relevant amendments on its website. The specified amendments shall take effect within seven (7) calendar days after their publication on the website." />
                  </li>
                  <li>
                    <Paragraph value="Any amendments to the Procedure from the date of their entry into force shall be binding on all persons using the Mobile Application, including those that started using the Mobile Application before the effective date of the amendments. In case the Partner disagrees with the amendments made, the Partner shall stop using the Mobile Application and inform the Platform. " />
                  </li>
                </ol>
                <b>
                  <Paragraph value="SECTION XIII." />
                </b>
                <b>
                  <Paragraph value="CONTACTS" />
                </b>
                <Paragraph value="If you have any queries or complaints relating to the performance of this License Agreement, or would like to withdraw your consent from the Agreement, you can contact us via email or by phone using the following contact details:" />
                <Paragraph value="Taxsee (Thailand) Co. Ltd." />
                <Paragraph value="Email: legal_th@taximaxim.com" />
                <Paragraph value="The original of this License Agreement is written in the English language. In the event of any conflict between the English and other language versions, the English version shall prevail." />

                <Button
                  className={styles.buttonConditions}
                  value="กลับ"
                  onClick={() => {
                    setShowConditions(false);
                  }}
                />
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
}

export default Result;
